if (typeof Things == 'undefined') Things = {};
Things.Router = Core.SubRouter.extend({

    routes: {
        '': 'devicelist',
        'product-catalog': 'productCatalog',
        'all': 'viewAll',
        'discovered': 'viewDiscovered',
        'new': 'newDevice',
        'cdncs-asset-report': 'cdnCsAssetReport',
        'teltonika-asset-report': 'teltonikaAssetReport',
        ':id': 'viewDevice',
        ':id/edit': 'editDevice',
    },

    productCatalog: function() {
        app.setMainView(new Things.ProductCatalogView(), 'directory');
    },
    viewAll: function() {
        app.setMainView(new Things.DeviceListView({groupUuid: Things.groupUuid, path: 'all'}), 'admin');
    },
    viewDiscovered: function() {
        app.setMainView(new Things.DeviceListView({groupUuid: Things.groupUuid, path: 'discovered'}), 'admin');
    },
    newDevice: function() {
        var view = new Things.ProductCatalogView();
        view.on('select', function(productId) {
            var constructor = Things.getDetailViewConstructorByProductId(productId);
            view = new constructor({editing: true, productId: productId});
            app.setMainView(view, 'directory');
            setTimeout(function() { view.focus(); }, 100);
        }, this);
        view.on('cancel', function() { history.back(); });
        app.setMainView(view, 'directory');
    },

    devicelist: function() {
        app.setMainView(new Things.DeviceListView({groupUuid: Things.groupUuid}), 'directory');
    },

    viewDevice: function(id) {
        Things.getDetailViewConstructorByDeviceId(id, function(constructor) {
            view = new constructor({id: id});
            app.setMainView(view, 'directory');
            setTimeout(function() { view.focus(); }, 100);
        });
    },

    editDevice: function(id) {
        Things.getDetailViewConstructorByDeviceId(id, function(constructor) {
            view = new constructor({id: id, editing: true});
            app.setMainView(view, 'directory');
            setTimeout(function() { view.focus(); }, 100);
        });

    },

    cdnCsAssetReport: function() {
        if (!Things.groupUuid) Things.groupUuid = Core.param('group');
        var view = new Things.CdnCsAssetReportView();
        app.setMainView(view, 'directory');
    },

    teltonikaAssetReport: function() {
        if (!Things.groupUuid) Things.groupUuid = Core.param('group');
        var view = new Things.TeltonikaAssetReportView();
        app.setMainView(view, 'directory');
    }

});

